import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sipHistoryApi } from "../../redux/features/sip/sipHistorySlice";
import Loader from "../../components/Loader";
import { Link } from "react-router-dom";

export default function SipHistory() {
  const dispatch = useDispatch();
  const [activeFDFilter, setActiveFDFilter] = useState("active");

  const getGoldFDHistory = (filter) => {
    setActiveFDFilter(filter);
  };

  const sipHistoryApiLoading = useSelector(
    (state) => state.sipHistorySlice.status
  );
  const sipHistoryApiResponse = useSelector(
    (state) => state.sipHistorySlice.data.sipList
  );

  useEffect(() => {
    dispatch(sipHistoryApi());
  }, [dispatch]);

  // Determine which list to display based on the active filter
  const currentList =
    activeFDFilter === "active"
      ? sipHistoryApiResponse?.activeList
      : sipHistoryApiResponse?.inActiveList;

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return (
    <div className="main_container">
      {/* ==BUTTONS====== */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <Button
          variant={activeFDFilter === "active" ? "contained" : "outlined"}
          onClick={() => getGoldFDHistory("active")}
          sx={{
            backgroundColor:
              activeFDFilter === "active" ? "#DA2128" : "transparent",
            color: activeFDFilter === "active" ? "white" : "#DA2128",
            borderColor:
              activeFDFilter === "active" ? "transparent" : "#DA2128",
            "&:hover": {
              backgroundColor: "#DA2128",
              color: "white",
              border: "#DA2128",
            },
          }}
        >
          Active
        </Button>

        <Button
          variant={activeFDFilter === "close" ? "contained" : "outlined"}
          onClick={() => getGoldFDHistory("close")}
          sx={{
            backgroundColor:
              activeFDFilter === "close" ? "#DA2128" : "transparent",
            color: activeFDFilter === "close" ? "white" : "#DA2128",
            borderColor: activeFDFilter === "close" ? "transparent" : "#DA2128",
            "&:hover": {
              backgroundColor: "#DA2128",
              color: "white",
              border: "#DA2128",
            },
          }}
        >
          InActive
        </Button>
      </div>

      {/* ==SIP's======== */}
      {sipHistoryApiLoading === "loading" ? (
        <div style={{ height: "70vh" }}>
          <Loader />
        </div>
      ) : currentList?.length > 0 ? (
        currentList?.map((item, index) => (
          <Link
            key={index}
            // to={`/dashboard/${item.subReferenceId}`}
            to={`/dashboard/profile/sip-history/${item.subReferenceId}`}
            state={{ metalType: item.metal_type }}
          >
            <div className="card p-2 history_card">
              <div className="history_card_inner">
                {/* IMG======== */}
                <div>
                  <img
                    src={
                      item.metal_type === "gold"
                        ? "/images/gold_sip.png"
                        : "/images/silver_sip.png"
                    }
                    alt="sipImg"
                    // width={60}
                    className="history_logo"
                  />
                </div>
                {/* DATA======= */}
                <div style={{ width: "100%" }}>
                  <div>
                    <div style={{ fontWeight: "600" }}>
                      AUGMONT (24 Karat{" "}
                      {item.metal_type == "gold" ? "Gold" : "Silver"})
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div>
                      <div>₹{item.amount} Monthly</div>
                      {/* <div>Every {item.day_of_month} date</div> */}
                      <div>{getOrdinal(item.day_of_month)} of every month</div>
                    </div>
                    {/* STATUS===== */}
                    <div
                      style={{
                        fontWeight: "bold",
                        color: item.status === "ACTIVE" ? "green" : "red",
                        textTransform: "uppercase",
                        alignContent: "end",
                      }}
                    >
                      {item.status}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))
      ) : (
        <div className="text-dark text-center">
          <img
            src="/images/history-not-found.png"
            className="noHistoryFound p-2"
            alt="No History"
          />
          <h6>No History Found</h6>
          <p>Fill this Space with your Order</p>
        </div>
      )}
    </div>
  );
}
